<template>
  <v-card elevation="0" :loading="loading">
    <v-card-text>
      <v-data-table
        :headers="table.headers"
        :items="taskEvents"
        item-key="name"
        class="elevation-1"
        :search="table.search"
      >
        <template #item.client="{ item }"> {{ item.node.user.firstName }} {{ item.node.user.lastName }} </template>
        <template #item.assignedTo="{ item }">
          {{ item.node.assignedTo.firstName }} {{ item.node.assignedTo.lastName }}
        </template>
        <template #item.title="{ item }">
          <a :href="`/task/${decodeId(item.node.id)}`" target="_blank">{{ item.node.title }}</a>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { TASK_EVENT_QUERY } from "@/graphql/queries/task";
import { decodeId } from "@/lib/string";

export default {
  name: "TaskHistory",
  props: {
    userId: {
      type: String,
      required: false,
    },
    assignedToId: {
      type: String,
      required: false,
    },
    incompleteTasks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskEvents: [],
      loading: true,
      table: {
        search: "",
        headers: [
          { text: "Client", value: "client", sortable: true },
          { text: "Task", value: "title", sortable: true },
          { text: "Created date", value: "node.taskEventDate", sortable: true },
          { text: "Task type", value: "node.taskType.title", sortable: true },
          { text: "Stage", value: "node.stage.title", sortable: true },
          { text: "Description", value: "node.description", sortable: true },
          { text: "Assigned to", value: "assignedTo" },
          { text: "Closed at", value: "node.closedAt", sortable: false },
        ],
      },
    };
  },
  methods: {
    decodeId(id) {
      return decodeId(id);
    },
  },
  apollo: {
    taskEvents: {
      query: TASK_EVENT_QUERY,
      variables() {
        if (this.userId) {
          let encoded_json_payload = btoa("UserNode:" + this.userId);
          return {
            userId: encoded_json_payload,
          };
        } else {
          let encoded_json_payload = btoa("UserNode:" + this.assignedToId);
          return {
            assignedToId: encoded_json_payload,
            closedAt_Isnull: this.incompleteTasks,
          };
        }
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        this.loading = false;
        return data.taskEvents.edges;
      },
    },
  },
};
</script>
